export default {
  VALIDATE_KUSPIT_ACCOUNT_REPOSITORY: Symbol.for('VALIDATE_KUSPIT_ACCOUNT_REPOSITORY'),
  VALIDATE_KUSPIT_ACCOUNT_COMMAND: Symbol.for('VALIDATE_KUSPIT_ACCOUNT_COMMAND'),
  // eslint-disable-next-line max-len
  PUBLISH_RECEIVED_STATUS_TO_EVENT_BUS_ON_KUSPIT_ACCOUNT_LINKING_STATUS_WEB_SOCKET_MESSAGE_SUBSCRIPTION:
    Symbol.for('PUBLISH_RECEIVED_STATUS_TO_EVENT_BUS_ON_KUSPIT_ACCOUNT_LINKING_STATUS_WEB_SOCKET_MESSAGE_SUBSCRIPTION'),
  UPDATE_KUSPIT_ON_BOARDING_STEP_REPOSITORY: Symbol.for('UPDATE_KUSPIT_ON_BOARDING_STEP_REPOSITORY'),
  UPDATE_KUSPIT_ON_BOARDING_STEP_COMMAND: Symbol.for('UPDATE_KUSPIT_ON_BOARDING_STEP_COMMAND'),
};
